import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { environment } from '../../../../../../environments/environment'
import { HelperService } from '../../../../services/helper.service'
import { UserData } from '../../../../types/auth.type'
import { ApiResponse } from '../../../../types/response.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class EditStakeModalService {
	quickBetAmounts$: BehaviorSubject<string[]> // Values for the stake shortcut numbers

	isQuickBetAmountsEditModalVisible = false

	constructor(
		private readonly httpClient: HttpClient,
		private readonly helperService: HelperService,
	) {
		this.quickBetAmounts$ = new BehaviorSubject<string[]>((this.helperService.getUserBetslipSettings()?.quickBetAmounts as string[]) ?? [])
	}

	/**
	 * Open the quick bet amounts edit modal
	 */
	openQuickBetAmountsEditModal() {
		this.isQuickBetAmountsEditModalVisible = true
	}

	/**
	 * Close the quick bet amounts edit modal
	 */
	dismissQuickBetAmountsEditModal() {
		this.isQuickBetAmountsEditModalVisible = false
	}

	updateQuickBetAmounts(data: string[]) {
		// Get the settings data from local storage
		const userData = this.helperService.getUserData()?.user_fields

		// Send request to the API endpoint
		return this.httpClient.post<ApiResponse<UserData[]>>(`${API_URL}/api/users/update_bet_configuration`, {
			ID: userData?.ID,
			BETSLIP: {
				...userData?.USER_BETSLIP,
				quickBetAmounts: data,
			},
		})
	}
}
